// #standard page 
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setActivePage } from '../../redux/actions';

import PageTitle from '../../components/PageTitle';


//#table
import GenericTable from '../../components/GenericTable';
import { dateFormat } from '../../helpers/formatter';

//#form
import {
    Card,
    CardBody,
    Nav,
    NavItem,
    NavLink,
    Alert,
    Row,
    Col
} from 'reactstrap';

//#other
import classnames from 'classnames';
import SuppRentView from './SuppRent';
import { fetchJSON } from '../../helpers/api';

import InfoBanner from './InfoBanner';


const columns = [
    {
        dataField: 'model',
        text: 'Model',
        sort: true
    },
    {
        dataField: 'serialNo',
        text: 'Serial No.',
        sort: true
    },
    {
        dataField: 'registrationNo',
        text: 'Reg No.',
        sort: true
    },
    {
        dataField: 'deliveryDate',
        text: 'Delivery Date',
        sort: true,
        formatter: dateFormat
    },
    {
        dataField: 'redeliveryDate',
        text: 'Redelivery Date',
        sort: true,
        formatter: dateFormat
    },
];


const columnsSummary = [
    {
        dataField: 'partyName',
        text: 'Lessee',
        sort: true
    },
    {
        dataField: 'model',
        text: 'Model',
        sort: true
    },
    {
        dataField: 'serialNo',
        text: 'Serial No.',
        sort: true
    },
    {
        dataField: 'registrationNo',
        text: 'Reg No.',
        sort: true
    },
    {
        dataField: 'deliveryDate',
        text: 'Delivery Date',
        sort: true,
        formatter: dateFormat
    },
    {
        dataField: 'redeliveryDate',
        text: 'Redelivery Date',
        sort: true,
        formatter: dateFormat
    },
];


const defaultSorted = [
    {
        dataField: 'redeliveryDate',
        order: 'desc',
    },
];

class MonthlyReports extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loading: true,
            tabHeadings: [],
            activeTab: '0',
            columns: columns
        };
    }

    componentDidMount = () => {
        this.props.setActivePage();

        this.loadSuppRentLeases();
    };

    expandRow = {
        renderer: lease => (
            <SuppRentView leaseNo={lease.leaseNo} />
        ),
    };

    async loadSuppRentLeases() {
        let url = '/portal/LeaseAccount/GetSuppRentLeases';
        let response = await fetchJSON(url);
        let lessees = [...new Set(response.data.map(({ partyName }) => partyName))];
        this.setState({
            data: response.data,
            loading: response.loading,
            tabHeadings: [...lessees],
            columns: lessees.length > 1 ? columnsSummary : columns
        });
    }

    /**
    * Toggle the tab
    */
    toggle = (tab: string) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
                columns: tab === "0" ? columnsSummary : columns
            });
        }
    };


    render() {
        return (
            <React.Fragment>
                <PageTitle
                    breadCrumbItems={[
                        { label: 'Monthly Billing Details', path: '/LeaseAccount/MonthlyReports', active: true },
                    ]}
                    title={'Monthly Billing Details'}
                />

                <InfoBanner />

                <Card>
                    <CardBody>
                        <React.Fragment>
                            {/* Single party */}
                            {this.state.tabHeadings.length <= 1 && (
                                <GenericTable
                                    columns={columns}
                                    data={this.state.data}
                                    keyField='keyField'
                                    defaultSorted={defaultSorted}
                                    loading={this.state.loading}
                                    expandRow={this.expandRow}
                                />
                            )}

                            {/* Multiple parties */}
                            {this.state.tabHeadings.length > 1 && (
                                <React.Fragment>
                                    <Nav tabs className="nav-bordered">
                                        {this.state.tabHeadings.map((tab, index) => {
                                            return (
                                                <NavItem key={index}>
                                                    <NavLink
                                                        href="#"
                                                        className={classnames({ active: this.state.activeTab === index.toString() }, { 'bg-light-lighten': index === 0 })}
                                                        onClick={() => {
                                                            this.toggle(index.toString());
                                                        }}>
                                                        <span>{tab}</span>
                                                    </NavLink>
                                                </NavItem>
                                            );
                                        })}
                                    </Nav>

                                    <br />
                                    <GenericTable
                                        columns={this.state.columns}
                                        data={this.state.data.filter(l => (this.state.activeTab === "0" && l.partyName !== this.state.tabHeadings[this.state.activeTab]) || (this.state.activeTab !== "0" && l.partyName === this.state.tabHeadings[this.state.activeTab]))}
                                        keyField='keyField'
                                        defaultSorted={defaultSorted}
                                        loading={this.state.loading}
                                        showMaxPageSize={true}
                                        expandRow={this.expandRow}
                                    />
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setActivePage: () => {
            dispatch(setActivePage("SuppRent_MonthlyReports"));
        }
    };
}

export default connect(null, mapDispatchToProps)(MonthlyReports);
